module.exports = __webpack_public_path__ + "d88a3b6361a7a415bb16b47a0e5c1244.MP3";